import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// We start with empty routes: they are configured later
const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
